import { render } from "./VertragNachweiseModalUpdate.pug?vue&type=template&id=85b1d674&lang=pug"
import script from "./VertragNachweiseModalUpdate.js?vue&type=script&lang=js"
export * from "./VertragNachweiseModalUpdate.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__